import React from "react";
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import '../assets/styles/Main.scss';
import profile_photo from '../assets/images/profile_photo.jpg';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <div className="image-crop">
            <img src={profile_photo} alt="Max Hilsdorf" />
          </div>
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://www.linkedin.com/in/max-hilsdorf/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
            <a href="mailto:max@maxhilsdorf.com"><EmailIcon/></a>
          </div>
          <h1>Max Hilsdorf</h1>
          <p>Data & AI Engineer</p>

          <div className="mobile_social_icons">
            <a href="https://www.linkedin.com/in/max-hilsdorf/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
            <a href="mailto:max@maxhilsdorf.com"><EmailIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;